// @flow
import PageNodeHeader from 'components/page/PageNodeHeader';
import { connect } from 'react-redux';

import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/page/PageNodeHeader';
import { withRouter } from 'react-router-dom';

export default withRouter(
  connect(
    (state: StateType): StateProps => ({
      acronyme: state.settingsState.acronyme,
      banniere: state.settingsState.banniere,
      clubName: state.settingsState.title,
      description: state.pageNodeState.pageNode.description ?
        state.pageNodeState.pageNode.description : state.pageDetailPreviewState.description,
      featured_media: state.pageNodeState.pageNode.featured_media ? 
        state.pageNodeState.pageNode.featured_media : state.pageDetailPreviewState.featured_media,
      meta_description: state.pageNodeState.pageNode.meta_description ? 
        state.pageNodeState.pageNode.meta_description : state.pageDetailPreviewState.meta_description,
      meta_title: state.pageNodeState.pageNode.meta_title ? 
        state.pageNodeState.pageNode.meta_title : state.pageDetailPreviewState.meta_title,
      rencontresLive: state.rencontreLiveState.rencontres ? Object.keys(state.rencontreLiveState.rencontres).length : 0,
      slug: state.pageNodeState.pageNode.slug ? state.pageNodeState.pageNode.slug : state.pageDetailPreviewState.slug,
      slug_parent: state.pageNodeState.pageNode.slug_parent ? 
        state.pageNodeState.pageNode.slug_parent : state.pageDetailPreviewState.slug_parent,
      templateDetail: state.pageDetailState.template,
      title: state.pageNodeState.pageNode.title ? 
        state.pageNodeState.pageNode.title : state.pageDetailPreviewState.title,
      titleParent: state.pageNodeState.pageNode.titleParent ? 
        state.pageNodeState.pageNode.titleParent: state.pageDetailPreviewState.title_parent,
    })
  )(PageNodeHeader)
);
